export default __webpack_public_path__ + "727d8c52f42d859ce2201c5f2cc37f7d.svg";